<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    withDefaults(
        defineProps<{
            label?: string;
        }>(),
        {
            label: "Anestesi",
        }
    );

    const fetchAnestesi = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/anestesi/fetchAnestesi", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/anestesi/anestesiSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta anestesi");
        }
    };
</script>

<template>
    <KAutocomplete
        name="anestesi"
        :label="label"
        v-bind="$attrs"
        :options="fetchAnestesi"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
